module.exports = __webpack_public_path__ + "assets/img/jk.b0c6c6cc.jpg";